export enum ActionType {
  GetPageTranslationSuccess = "GetPageTranslationSuccess",
  GetCommonTranslationSuccess = "GetCommonTranslationSuccess",
  SetPageData = "SetPageData",
  ShowPopup = "ShowPopup",
  HidePopup = "HidePopup",
  SetLocale = "SetLocale",
  SetLoading = "SetLoading",
  SetPageLoading = "SetPageLoading",
  SetCountries = "SetCountries",
  SetCategory = "SetCategory",
  SetCategories = "SetCategories",
  SetUserData = "SetUserData",
  SetJobsFeedData = "SetJobsFeedData",
}

export interface IAction<TType, TPayload> {
  type: TType;
  payload: TPayload;
}
